import TtamLibraryTips from './tips/index.vue';
import TtamLibraryListItem from './list-item/index.vue';
import TtamLibraryListEmpty from './list-empty/index.vue';
import TtamLibraryHeader from './header/index.vue';
import TtamLibrayHeaderLite from './header/index-lite.vue';
import TtamLibraryListEmptyLite from './list-empty/list-empty-lite.vue';

import * as hooks from './hooks/props';

export default {
  ...hooks,
  TtamLibraryTips,
  TtamLibraryHeader,
  TtamLibrayHeaderLite,
  TtamLibraryListItem,
  TtamLibraryListEmpty,
  TtamLibraryListEmptyLite,
};
